import {
    GET_PRODUCTION_ENTRY_LIST_PROGRESS, GET_PRODUCTION_ENTRY_LIST_SUCCESS, GET_PRODUCTION_ENTRY_LIST_FAILURE,
    ADD_PRODUCTION_ENTRY_PROGRESS, ADD_PRODUCTION_ENTRY_SUCCESS, ADD_PRODUCTION_ENTRY_FAILURE,
    EDIT_DELETE_PRODUCTION_ENTRY_PROGRESS, EDIT_DELETE_PRODUCTION_ENTRY_SUCCESS, EDIT_DELETE_PRODUCTION_ENTRY_FAILURE,
    ////


    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    production_entry: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const production_entry_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_PRODUCTION_ENTRY_LIST_SUCCESS:
            return { ...state, production_entry: action.production_entry, loading: false };
        case GET_PRODUCTION_ENTRY_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_PRODUCTION_ENTRY_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_PRODUCTION_ENTRY_PROGRESS:
            return { ...state, loading: true };
        case ADD_PRODUCTION_ENTRY_SUCCESS:
            return { ...state, production_entry: [...state.production_entry, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_PRODUCTION_ENTRY_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_PRODUCTION_ENTRY_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_PRODUCTION_ENTRY_SUCCESS:
            return {
                ...state,
                production_entry: state.production_entry.map((production_entry) =>
                    production_entry.id === action.payload.id ? action.payload : production_entry
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_PRODUCTION_ENTRY_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default production_entry_reducer;